import {
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Text,
} from "@src/appV2/redesign/system/ui-components";
import pluralize from "pluralize";

import { type CaseHistoryData } from "../types";

interface CaseHistoryListItemProps {
  caseData: CaseHistoryData;
  onClick: () => void;
}

export function CaseHistoryListItem(props: CaseHistoryListItemProps) {
  const { caseData, onClick } = props;
  const visitCount = caseData.attributes.visits?.length ?? 0;

  return (
    <ListItemButton divider onClick={onClick}>
      <ListItemIcon iconType="folder" />
      <ListItemText
        disableTypography
        primary={
          <Text semibold variant="h5" sx={{ textWrap: "balance" }}>
            {caseData.attributes.patient.attributes.externalPatientIdentifier}
          </Text>
        }
        secondary={
          <Text variant="body2" mt={2}>
            {visitCount} {pluralize("visit", visitCount)}
          </Text>
        }
      />
    </ListItemButton>
  );
}
